import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ConstructionIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_589_3199)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.5 17.4999C14.5787 14.8211 12.0197 12.8635 9.05118 12.8635C6.08268 12.8635 3.42126 14.8211 2.5 17.4999",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.94837 3.59091V0.5M3.31836 6.57878H14.5782M4.75143 7.71212C4.85379 9.97879 6.6963 11.8333 8.94827 11.8333C11.3026 11.8333 13.1451 9.97879 13.1451 7.60909V5.75455C13.1451 3.38485 11.3026 1.5303 8.94827 1.5303C6.6963 1.5303 4.85379 3.38485 4.75143 5.65152V7.71212Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_589_3199",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
